import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Threads feed ("Sažetak na Threadsu"). Threads posts as the Instagram account
 * and shows the link as a card: the image over the domain and headline.
 */
@Component({
  selector: 'app-meta-threads-feed',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './threads-feed.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './threads-feed.component.scss'
})
export class MetaThreadsFeedPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly accountName = MetaPreviewCopy.INSTAGRAM_ACCOUNT_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** Two lines on the mock: the first paragraph, cut on a word at 80 characters. */
  get primaryText(): TruncatedCopy {
    return MetaPreviewCopy.firstParagraph(MetaPreviewCopy.primaryText(this.data), 80);
  }

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get domain(): string {
    return MetaPreviewCopy.domain(this.data);
  }
}
